import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Checkbox,
  Image,
  LargeCloseIcon,
  RawButton,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

import GridBackground from '@/assets/new-investments/grid-background.svg';

interface Props {
  children?: React.ReactNode;
  onClose: () => void;
  isCloseForever: boolean;
  setIsCloseForever: (value: boolean) => void;
}

const SeeWhatsNewPopupWrapper: React.FC<Props> = ({ children, onClose, isCloseForever, setIsCloseForever }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Box
      data-testid="see-whats-new_popup-wrapper"
      style={{ position: 'relative' }}
      overflow="hidden"
      round="moduleRound"
    >
      <Image
        data-testid="see-whats-new_popup-wrapper_background"
        src={GridBackground}
        style={{
          position: 'absolute',
          left: -20,
          top: -20,
          zIndex: 1,
        }}
      />
      <Box
        data-testid="see-whats-new_popup-wrapper_content"
        style={{ zIndex: 2 }}
        pad={isMobile ? { horizontal: 'spacing16', vertical: 'spacing32' } : 'spacing24'}
      >
        <Box
          data-testid="see-whats-new_popup-wrapper_header"
          style={{ position: 'relative' }}
          direction="row"
          justify="end"
          align="center"
        >
          {isMobile ? null : (
            <Box
              direction="row"
              align="center"
              gap="spacing4"
            >
              <Text color="textSecondary" weight={500} size="small">
                {t("Don't show again")}
              </Text>
              <Checkbox
                testId="see-whats-new_dont-show-again"
                checked={isCloseForever}
                onChange={setIsCloseForever}
              />
            </Box>
          )}
          <RawButton
            data-testid="see-whats-new-close_button"
            onClick={onClose}
            style={{ height: '24px' }}
          >
            <LargeCloseIcon size="24px" />
          </RawButton>
        </Box>
        {children}
      </Box>
    </Box>
  );
};

export default SeeWhatsNewPopupWrapper;
